export default __webpack_public_path__ + "static/logo-filled-b0b1fc1fb9c92beab94a2d860315fbb5.svg";